import { memo } from 'react';
import { cn } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import Button from '@UI/Button';
import styles from './ContactWithQualityDep.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface ContactWithQualityDepProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  feedbackLink: string;
}

const ContactWithQualityDep: FC<ContactWithQualityDepProps> = (props) => {
  const { className, feedbackLink, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.wrapper, className)}>
      <div className={styles.container}>
        <div className={styles.title}>{t('contact-quality-department.title')}</div>

        <div className={styles.text}>{t('contact-quality-department.description')}</div>

        <Button className={styles.button} theme='primary' view='main' to={feedbackLink}>
          {t('contact-quality-department.write-us')}
        </Button>

        <div className={styles.nuans}>{t('ui.not-oferta')}</div>
      </div>
    </div>
  );
};

export default memo(ContactWithQualityDep);
